export const uk = {
    'button-cancel': 'Отмена',
    'button-submit': 'Применить',
    'highest-bid': 'Обратите внимание — остановлена слишком высокая ставка'
};
